import { render, staticRenderFns } from "./picture-text.vue?vue&type=template&id=098183d9&scoped=true&"
import script from "./picture-text.vue?vue&type=script&lang=js&"
export * from "./picture-text.vue?vue&type=script&lang=js&"
import style0 from "./picture-text.vue?vue&type=style&index=0&id=098183d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098183d9",
  null
  
)

export default component.exports